import { AddressDTO } from "./addressDTO";

export class ClientDTO{
    public id!: number;
    public name!: string;
    public externalId!: string;
    public customerId!: number;
    public addressList!: AddressDTO[];
    public deleted!: boolean;

    constructor(){
        this.addressList = new Array();
    }
}